<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important">
    <span>{{'down_sign_transaction.result_detail' | translate}} {{data.code}} 
        ({{'down_sign_transaction.time_start' | translate}} {{data.createdTime}})
    </span>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-dialog-content>
    <mat-divider></mat-divider>
    <div class="col-12 mt-2">
        <mat-table [dataSource]="data.dataSource">
            <!-- số thứ tự Column -->
            <!-- <ng-container matColumnDef="stt" style="width: 55px !important;">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="width: 55px !important;">
                    {{ "down_sign_transaction.header_table.index" | translate }}
                </mat-header-cell>
                <mat-cell style="width: 55px !important;" *matCellDef="let element; let i = index" class="text-center">
                    {{ i + 1 }}
                </mat-cell>
            </ng-container> -->
            <ng-container matColumnDef="STT">
                <mat-header-cell *matHeaderCellDef style="width: 55px;"
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{ "down_sign_transaction.header_table.index" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index" style="width: 55px;"
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                    (click)="$event.stopPropagation()">
                    {{ i + 1 }}
                </mat-cell>
            </ng-container>
            <!-- loại chữ ký Column -->
            <ng-container matColumnDef="signType">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="width: 15%;">
                    {{ "down_sign_transaction.header_table.sign_type" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                   {{renderType(element.type)}}
                </mat-cell>
            </ng-container>
            <!-- trạng thái Column -->
            <ng-container matColumnDef="status" style="width: 15%;">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom text-center">
                    {{ "down_sign_transaction.header_table.status" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center justify-content-center">
                    {{renderStatus(element.status)}}
                </mat-cell>
            </ng-container>
            <!-- ngày hết hạn Column -->
            <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom text-center" style="width: 20%;">
                    {{ "down_sign_transaction.header_table.end_date" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center justify-content-center">
                    {{element.expiredTime}}
                </mat-cell>
            </ng-container>
            <!-- loại lỗi Column -->
            <ng-container matColumnDef="errorType">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                    {{ "down_sign_transaction.header_table.error_type" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{renderError(element.errorCode)}}
                </mat-cell>
            </ng-container>
            <!-- mã lỗi Column -->
            <ng-container matColumnDef="errorCode">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="width: 15%;">
                    {{ "down_sign_transaction.header_table.error_code" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.errorMessage}}
                </mat-cell>
            </ng-container>
            <!-- ngày cập nhật Column -->
            <ng-container matColumnDef="updateDate">
                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom text-center" style="width: 20%;">
                    {{ "down_sign_transaction.header_table.update_date" | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="text-center justify-content-center">
                    {{element.updatedTime}}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
            </mat-row>
        </mat-table>
    </div>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center mt-2">
    <!--build icon, set default cancel-->
    <button mat-raised-button color="primary" class="ml-2" (click)="close()">
        <mat-icon class="mr-2">cancel</mat-icon>{{ "button.close" | translate }}
    </button>
</div>